import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import "../servicesOperation.css";
import InputAutocomplete from "../InputAutocomplete_Form";
import Checkbox from "@mui/material/Checkbox";
import MuiAlert from "@mui/material/Alert";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import {
  options_origen_devolucion,
  options_deposito_destino,
  options_condicion,
  options_sintoma,
  options_aceptamos_devolucion_safe,
  data_aceptamos_devolucion,
} from "../Helper/data_Admin";
import { TextField } from "@mui/material";
import useAuth from "hooks/useAuth";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

// Definimos el componente Admin
const Admin_Form_Body_finalizado = ({
  formData,
  setFormData,
  isLoading,
  isSubmitting,
  isSubmitSuccessful,
  dataCondicion,
  dataDeposito_destino,
  dataOrigen_devolucion,
  dataSintoma,
  dataAceptamos_Dev,
  dataTecnico_responsable,
  handleSubmit,
}) => {
  console.log(formData);
  // Hook de autenticación para obtener permisos del usuario
  const { user } = useAuth();

  // Verificar si el usuario tiene permisos de administrador
  const hasAdminPermission =
    user?.permissions?.includes("ServiceOp:viewSAdmin") || false;

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <>
          <Box sx={{ flexGrow: 1, marginTop: "16px" }}>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              {/* <Grid item xs={12} sm={4} md={4} key="1">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_origen_dev"
                  label="Origen Devolución"
                  value={formData.origen_devolucion_name}
                  disabled={!hasAdminPermission}
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={4} md={4} key="2">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_deposito_dest"
                  label="Destino Devolucion"
                  value={formData.deposito_destino_name}
                  disabled={!hasAdminPermission}
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={4} md={4} key="3">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_condicion"
                  label="Condición"
                  value={formData.condition_name}
                  disabled={!hasAdminPermission}
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={4} md={4} key="4">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_sintoma"
                  label="Síntoma"
                  value={formData.sintoma_name}
                  disabled={!hasAdminPermission}
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="5">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_aceptamos_devolucion"
                  label="Aceptamos la devolucion"
                  value={formData.aceptamos_devolucion_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>

              <Grid item xs={12} sm={4} md={4} key="6">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_descripcion"
                  label="Descripción"
                  value={formData.descripcion_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="7">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_lote"
                  label="Lote"
                  value={formData.lote_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="8">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_falla"
                  label="Falla"
                  value={formData.falla_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="9">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_componente"
                  label="Componente"
                  value={formData.componente_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="10">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_estetica_packaging"
                  label="Estética Packaging"
                  value={formData.estetica_packaging_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="11">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_estetica_producto"
                  label="Estética Producto"
                  value={formData.estetica_producto_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              {/* <Grid item  xs={12} sm={4} md={4}  key='12'>
                                            <TextField sx={{width: '100%'}} id="id_deposito_dest" label="Depósito Destino" value={formData.deposito_destino_name} disabled={!hasAdminPermission} />
                                        </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="13">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_reparacion"
                  label="Reparación"
                  value={formData.reparacion_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="14">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_motivo_scrap"
                  label="Motivo del Scrap"
                  value={formData.motivo_del_scrap_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="15">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_codigo_barra"
                  label="Código de Barra"
                  value={formData.codigo_barra}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="16">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_estado_sku"
                  label="Estado del SKU"
                  value={formData.estado_sku_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="17">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_responsable"
                  label="Responsable"
                  value={formData.responsable_name}
                  disabled={!hasAdminPermission}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="18">
                <TextField
                  sx={{ width: "100%" }}
                  id="id_comentarios"
                  label="Comentarios"
                  value={formData.comentarios}
                  disabled={!hasAdminPermission}
                />
              </Grid>
            </Grid>
          </Box>

          <div className="send_btn_container_admin">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={(e) => handleSubmit(e, "finalize")} // pasar 'finalize' como tipo de acción
            >
              Re abrir
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default Admin_Form_Body_finalizado;
